import { defineStore } from "pinia";
export interface IRootObject {
  bluetoothInfo: any;
  piniaMsg?: string;
  name?: string;
  age?: string;
  count?: number;
}
export const useAlertsStore = defineStore("storeA", {
  state: (): IRootObject => {
    return {
      piniaMsg: "hello pinia",
      name: "xiaoyue",
      age: "18",
      count: 0,
      bluetoothInfo: null,
    };
  },
  getters: {},
  actions: {
    // setName(data: string) {
    //   console.log("data11", data);
    //   this.name = data;
    // },
    setName(data: string) {
      console.log("data11", data);
      this.name = data;
    },
  },
});
